import { render, staticRenderFns } from "./STableLotsComp.vue?vue&type=template&id=56d80a32&"
import script from "./STableLotsComp.vue?vue&type=script&lang=js&"
export * from "./STableLotsComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports